import React from 'react';
import { Button } from 'primereact/button';
import EldLogo from '../../../assets/logos/Logo-ELD-02 transparent.png';
import DaysToEndOfMonth from '../../common/DaysToEndOfMonth';

const MenubarContent = ({
  dictionary,
  contentProps,
  activeTab,
  setActiveTab,
  setShowEspTable,
  userIsAdmin,
  navigate,
  POST_TAB,
  ESP_TAB,
}) => {
  const start = (
    <>
      <h1>
        <i className="pi pi-user"></i>
        {dictionary.content_hello + contentProps.loggedUser}
      </h1>
      <DaysToEndOfMonth />
    </>
  );

  const end = (
    <>
      <div className="table-tabs">
        <Button
          label={dictionary.user_logs_btn_post_table}
          className={activeTab === POST_TAB ? 'active' : ''}
          icon="pi pi-table"
          onClick={() => {
            setShowEspTable(false);
            setActiveTab(POST_TAB);
          }}
        />
        <Button
          label={dictionary.user_logs_btn_esp_table}
          className={activeTab === ESP_TAB ? 'active' : ''}
          icon="pi pi-table"
          onClick={() => {
            setActiveTab(ESP_TAB);
            if (userIsAdmin) {
              setShowEspTable(true);
            }
          }}
        />
      </div>
      <div className='doc-wrapper'>
        <Button icon="pi pi-info-circle" label="Documentation" onClick={() => navigate('/documentation')} />
        <img alt="logo" src={EldLogo} className="mr-2" />
      </div>
    </>
  );

  return { start, end };
};

export default MenubarContent;
